import React from "react";
import { useSelector } from "react-redux";
import Loading from "components/shared/loader/loader";
import SmsVerificationDialog from "components/public-dashboard/features/sms_verification";
import SignupForm from "./signup_form";
import useDocumentTitle from "../../../../hooks/useDocumentTitle";

export default function Signup(props) {
  useDocumentTitle(
    "Sign Up to Save Time and Track Transactions | YOOZ",
    "Create your free account. Explore YOOZ's core features. Track transactions, pay bills and top up faster. See what's included. Sign up to YOOZ It."
  );

  const {
    onSubmit,
    onChangeFormField,
    onChangeFormFieldPhone,
    validateCheckBox,
    isChecked,
    isVisible,
    countries,
    mobNum,
    isRegDisable,
    error,
    tosError,
    setVisibility,
    onOtpVarify,
    otpError,
    resendOtp,
    tokens,
    setMobileOtp,
    password,
    confirmPwd,
    timeoutDuration,
    otpType,
    setOtpType,
    sendEmailOtp,
    sendSMSOtp,
    lastEmailOtpExpirationTime,
    lastSMSOtpExpirationTime,
    email

  } = props;

  const loading = useSelector((state) => state.uiGlobal.loading);
  return (
    <div>
      {loading && <Loading />}
      {isVisible && (
        <SmsVerificationDialog
          open={isVisible}
          mobile={mobNum}
          email={email}
          sendSMSOtp={sendSMSOtp}
          lastEmailOtpExpirationTime={lastEmailOtpExpirationTime}
          lastSMSOtpExpirationTime={lastSMSOtpExpirationTime}
          sendEmailOtp={sendEmailOtp }
          timeoutDuration={timeoutDuration}
          otpType={otpType}
          setOtpType={setOtpType}
          handleClose={setVisibility}
          setMobileOtp={setMobileOtp}
          onOtpVarify={onOtpVarify}
          resendOtp={resendOtp}
          error={otpError}
          title="Sign Up"
          title2="Verification"
        />
      )}
      <SignupForm
        onSubmit={onSubmit}
        onChangeFormField={onChangeFormField}
        onChangeFormFieldPhone={onChangeFormFieldPhone}
        validateCheckBox={validateCheckBox}
        isChecked={isChecked}
        countries={countries}
        mobNum={mobNum}
        isRegDisable={isRegDisable}
        error={error}
        tosError={tosError}
        confirmPwd={confirmPwd}
        password={password}
      />
    </div>
  );
}
